import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form"]
  static values = {
    identifier: String
  }

  toggle() {
    this.formTarget.classList.toggle("hidden")
  }
  
  showForm() {
    // Hide display, show form
    if (this.hasDisplayTarget) {
      this.displayTargets.forEach(target => {
        target.classList.add('hidden')
      })
    }
    this.formTarget.classList.remove('hidden')
    
    // Focus first input
    const input = this.formTarget.querySelector('input, textarea, select')
    if (input) {
      input.focus()
    }
  }
  
  hideForm() {
    // Show display, hide form
    if (this.hasDisplayTarget) {
      this.displayTargets.forEach(target => {
        target.classList.remove('hidden')
      })
    }
    this.formTarget.classList.add('hidden')
  }
  
  stopPropagation(event) {
    event.stopPropagation()
  }
  
  handleResponse(event) {
    if (event.detail.success) {
      this.formTarget.classList.add("hidden")
    }
  }
} 